import React, { useImperativeHandle, useState } from "react";
import { ReusableModal } from "ui/molecules/modal/ReusableModal";
import GenerateReportFormTemplate from "../templates/GenerateReportFormTemplate";
import { ResidentModel } from "app/services/api/types/residents/models/ResidentModel";

interface Ref {
  show: (initialResident?: ResidentModel) => void;
}

interface Props {
  onSuccess?: (newIds: number[]) => void;
}

const GenerateReportModal = React.forwardRef<Ref, Props>(
  ({ onSuccess }, ref) => {
    const [showing, setShowing] = useState(false);
    const [initialResident, setInitialResident] = useState<
      ResidentModel | undefined
    >(undefined);

    useImperativeHandle(ref, () => ({
      show: (initialResident?: ResidentModel) => {
        setInitialResident(initialResident);
        setShowing(true);
      },
    }));

    const handleClose = () => {
      setShowing(false);
    };

    return (
      <ReusableModal
        isVisible={showing}
        onClose={handleClose}
        className="w-full max-w-[588px] mx-auto"
        title="Generate Report"
        hasCancelButton
      >
        <GenerateReportFormTemplate
          initialResident={initialResident}
          onClose={handleClose}
          onSuccess={onSuccess}
        ></GenerateReportFormTemplate>
      </ReusableModal>
    );
  },
);

GenerateReportModal.displayName = "GenerateReportModal";
export { GenerateReportModal };
